<template>
  <transition name="fade">
    <div class="popup-modal" v-if="isVisible">
      <div class="window">
        <slot></slot>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: "PopupModal",

  data: () => ({
    isVisible: false,
  }),

  methods: {
    open() {
      this.isVisible = true;
    },
    close() {
      this.isVisible = false;
    },
  },
};
</script>

<style scoped>
/* css class for the transition */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.1s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.popup-modal {
  background-color: rgba(0, 0, 0, 0.5);
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 0.5rem;
  display: flex;
  align-items: center;
  margin: 0px auto !important;
  /* z-index: 1; */
  z-index: 99999;
}

.window {
  /* position: relative;
  margin: 12px auto;
  width: fit-content;
  margin: 0px auto !important;
  top: 0%; */
  /* transform: translateY(-50%); */
  /* margin-top: calc(100vh - 54%);
      position: relative;
      bottom: 275px; */
  /* box-shadow: 2px 4px 8px rgba(0, 0, 0, 0.2); */
}

.window {
  position: absolute;
  margin: 12px auto;
  width: -webkit-fit-content;
  width: -moz-fit-content;
  width: fit-content;
  margin: 0px auto !important;
  top: 20%;
  transform: translateY(-15%);
  left: 0px;
  right: 0px;
}

.add-form-div {
  position: static !important;
}
@media only screen and (max-width: 600px) {
  .window {
    width: 100%;
    top: 20px;
    /* margin-top: calc(100vh - 634px); */
  }
}
</style>
